import includesPlan from '~/utils/includesPlan';
import { PRO_PLANS } from '~/constants';

const isProPlan = (plan) => includesPlan(PRO_PLANS, plan);

export default isProPlan;
